import { ALTIN_PARLAK, INK, KAGIT, CIZGI_KOYU, DISPLAY, GOVDE, CONTACT, BLOK } from "../data/constants";
import { useMobile } from "../hooks/useMobile";

/* =============================================================
   ALT BİLGİ

   Eski alt bilgide lacivert gradyan + noktalı ızgara dokusu vardı.
   Yeni dilde kapanış bloğu ile alt bilgi AYNI koyu zemini paylaşıyor,
   araya çizgi giriyor. Dekoratif doku kaldırıldı.

   Gizli yönetim girişi (telife 5 kez tıklama) KORUNDU: canlıda çalışan
   bir davranış, kaldırmak paneli erişilemez yapardı.
   ============================================================= */

const BAGLANTILAR = {
"Hizmetler": [
    ["Marka stratejisi", "brand", "/hizmetler/brand"],
    ["Dijital reklam", "ads", "/hizmetler/ads"],
    ["Prodüksiyon", "production", "/hizmetler/production"],
    ["Sosyal medya", "social", "/hizmetler/social"],
    ["E-ticaret", "trendyol", "/hizmetler/trendyol"],
    ["SEO ve GEO", "seo", "/hizmetler/seo"],
  ],
"Şirket": [
    ["Hakkımızda", "about", "/hakkimizda"],
    ["Blog", "blog", "/blog"],
    ["İletişim", "contact", "/iletisim"],
  ],
};

export default function Footer({ onNavigate }) {
  const mobil = useMobile();
  const soluk = "rgba(251,250,246,0.55)";

  const baslik = {
    fontFamily: DISPLAY, fontSize: 11.5, fontWeight: 700, color: KAGIT,
    letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 15px",
  };
  const bag = {
    fontFamily: GOVDE, fontSize: 14.5, color: soluk, display: "block",
    marginBottom: 9, transition: "color .18s ease",
  };

  return (
    <footer style={{ background: BLOK, padding: mobil ? "0 20px 34px" : "0 30px 38px" }}><div style={{ maxWidth: 1200, margin: "0 auto" }}><div style={{
          borderTop: `1px solid ${CIZGI_KOYU}`, paddingTop: 48,
          display: "grid",
          gridTemplateColumns: mobil ? "1fr 1fr" : "1.6fr 1fr 1fr 1fr",
          gap: mobil ? "34px 22px" : 38,
        }}><div style={{ gridColumn: mobil ? "1 / -1" : "auto" }}><a href="/" onClick={(e) => { e.preventDefault(); onNavigate("home"); }}
               style={{ fontFamily: DISPLAY, fontWeight: 800, fontSize: 19,
                        letterSpacing: "-0.04em", color: KAGIT }}>
              WHAYNS<span style={{ color: ALTIN_PARLAK }}>.</span></a><p style={{ fontFamily: GOVDE, fontSize: 14.5, color: soluk,
                        lineHeight: 1.6, maxWidth: "34ch", marginTop: 15 }}>
              Türkiye'de Amerikan reklamcılık anlayışıyla çalışan tam kapsamlı
              marka ve pazarlama ajansı.
            </p></div>

          {Object.entries(BAGLANTILAR).map(([bas, ogeler]) => (
            <div key={bas}><h4 style={baslik}>{bas}</h4>
              {ogeler.map(([et, sayfa, href]) => (
                <a key={et} href={href}
                   onClick={(e) => { e.preventDefault(); onNavigate(sayfa); }}
                   style={bag}
                   onMouseEnter={(e) => { e.currentTarget.style.color = KAGIT; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = soluk; }}
                >{et}</a>
              ))}
            </div>
          ))}

          <div><h4 style={baslik}>İletişim</h4><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} style={bag}
               onMouseEnter={(e) => { e.currentTarget.style.color = KAGIT; }}
               onMouseLeave={(e) => { e.currentTarget.style.color = soluk; }}
            >{CONTACT.phone}</a><a href={`mailto:${CONTACT.email}`} style={bag}
               onMouseEnter={(e) => { e.currentTarget.style.color = KAGIT; }}
               onMouseLeave={(e) => { e.currentTarget.style.color = soluk; }}
            >{CONTACT.email}</a><span style={{ ...bag, cursor: "default" }}>{CONTACT.address}</span></div></div><div style={{
          marginTop: 44, paddingTop: 20, borderTop: `1px solid ${CIZGI_KOYU}`,
          display: "flex", flexDirection: mobil ? "column" : "row",
          justifyContent: "space-between", alignItems: mobil ? "flex-start" : "center",
          gap: 14, fontFamily: GOVDE, fontSize: 13, color: soluk,
        }}><p
            style={{ margin: 0, userSelect: "none" }}
            onClick={() => {
              // Gizli yönetim girişi: telife 5 kez tıklama. Canlıdaki
              // davranış korunuyor, panelin başka girişi yok.
              if (window._adminClicks === undefined) window._adminClicks = 0;
              window._adminClicks++;
              if (window._adminClicks >= 5) { window._adminClicks = 0; onNavigate("admin"); }
            }}
          >© {new Date().getFullYear()} Whayns Dijital. Tüm hakları saklıdır.</p><div style={{ display: "flex", gap: 18 }}>
            {["Instagram", "LinkedIn", "YouTube"].map((s) => (
              <a key={s} href="#" rel="noopener noreferrer nofollow"aria-label={`${s} sayfamız`} style={{ color: soluk }}
                 onMouseEnter={(e) => { e.currentTarget.style.color = ALTIN_PARLAK; }}
                 onMouseLeave={(e) => { e.currentTarget.style.color = soluk; }}
              >{s}</a>
            ))}
          </div></div></div></footer>
  );
}
